import { callServiceInternal, getParams, getScope, getServiceResult, getState } from "./dataService";
import { signal } from "@preact/signals-react";

export interface ODataQueryOptions {
  $filter?: string;
  $orderby?: string;
  $top?: number;
  $skip?: number;
  $select?: string;
  $apply?: string;
}

export const ODataFieldsNameList = [
  "Filter",
  "GroupBy",
  "Aggregate",
  "OrderBy",
  "Top",
  "Skip",
  "Select",
  "Expand",
  "OData",
  "PostProcess"
]

function parseQueryString(query: string): Record<string, unknown> {
  query = query.replace("/aggregate($count as count)", '');

  return Object.fromEntries(new URLSearchParams(query).entries());
}

export async function callOdataQuery({ options, context, serviceConfig, config }) {
  const service = {
    Loading: signal(false),
    Data: signal([]),
    State: signal(""),
    Config: signal(serviceConfig)
  };

  const { state, form, parentState } = getState(context);
  state["NGService"][serviceConfig.Name] = service;

  service.State.value = "requesting";
  service.Loading.value = true;

  const odataParams = parseQueryString(options);

  // Take the params that are non part of OData and add them to the service param
  const nonODataFields = config.Service.Fields
    .filter(f => !options.includes(f.Name?.toLowerCase()));

  const serviceConfigWithoutOdata = { ...serviceConfig, Fields: nonODataFields };

  // get scope
  const scope = getScope(context, serviceConfigWithoutOdata, state, form, {}, parentState);
  const [params, isValid] = getParams(serviceConfigWithoutOdata, scope);
  if (!isValid) return [];

  params.OData = odataParams;
  service.Loading.value = true;

  // call service
  const response = await callServiceInternal(serviceConfigWithoutOdata, params, service, scope, context);

  if (response.error) {
    service.Loading.value = false;
    service.Data.value = [];
    service.State.value = "error";
    return [];
  }

  // get service result based on service bindings
  const result = getServiceResult(serviceConfigWithoutOdata, scope, response.data);

  // map rows based on bindings
  service.Loading.value = false;
  service.Data.value = result["Rows"] ?? [];
  service.State.value = "success";

  return result["Rows"] ?? [];
}
